export default __webpack_public_path__ + "bedroom-illustration.webp";